/**
 * Web hook wrapper around the shared `canRefreshPricing` predicate (moved to
 * `@elara/client-core/lib/can-refresh-pricing`, ELARA-708 follow-up, so mobile can use the exact same
 * logic). Only the `useItineraryState()` binding stays web-specific.
 */

import type { FlightOptionModel } from '@elara/client-core/models/FlightOptionModel';
import type { RoomOptionModel } from '@elara/client-core/models/RoomOptionModel';
import type { ShortlistItemType } from '@elara/domain/models/schemas/shortlist-schemas';

import { canRefreshPricing } from '@elara/client-core/lib/can-refresh-pricing';

import { useItineraryState } from '#states/hooks.js';

export { canRefreshPricing } from '@elara/client-core/lib/can-refresh-pricing';

/** Hook wrapper around canRefreshPricing that reads itinerary state from context. */
export function useCanRefreshPricing(
  type: ShortlistItemType | string,
  model: FlightOptionModel | RoomOptionModel | undefined,
): boolean {
  const itineraryItems = useItineraryState().items;
  return canRefreshPricing(type, model, itineraryItems);
}
